<script>
    export let checked;
    export let ariaLabel = 'Toggle switch';
    export let offWarning = false; // Optional warning colour when toggle is set to off
</script>

<style>
    .toggle-switch {
        position: relative;
        display: inline-block;
        width: 54px;
        height: 26px;
        margin: 0;
    }

    .toggle-switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0; 
        left: 0; 
        right: 0; 
        bottom: 0;
        background-color: #808080;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 13px;
    }

    .slider.slider-danger {
        background-color: #bb2e3b;
    }

    .slider:before {
        position: absolute;
        content: "";
        left: 4px;
        top: 4px;
        width: 18px;
        height: 18px;
        background: white;
        border-radius: 50%;
        transition: 0.2s;
        box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    }

    input:checked + .slider {
        background-color: #6da074;
    }

    input:checked + .slider:before {
        transform: translateX(28px);
    }

    .slider .label {
        position: absolute;
        left: auto;
        right: 9px;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.8em;
        font-weight: 600;
        letter-spacing: 0.05em;
        color: white;
        pointer-events: none;
        user-select: none;
    }

    input:checked + .slider .label {
        right: auto;
        left: 9px;
    }

    input:focus + .slider {
        outline: none;
	    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.5);
	    border-radius: 13px;
    }
</style>

<label class="toggle-switch">
    <input
        type="checkbox"
        bind:checked
        aria-label={ariaLabel}
    />
    <span class="slider" class:slider-danger={offWarning && !checked}>
        <span class="label">
            {checked ? 'YES' : 'NO'}
        </span>
    </span>
</label>